import styled from "styled-components";

// Now also used by the logged-out variant (LoggedOutHome), so these live in
// the shared Homepage/styledComponents — re-exported here since
// ActivityFeedHome/index.tsx already imports them from this local file.
export { CappedContent, HomepageContainer } from "../styledComponents";

export const FeedColumns = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 32px;
  max-width: 100%;
  min-width: 0;

  @media (max-width: 900px) {
    /* stretch, not the flex-start above: once this is a column, align-items
       governs the horizontal axis, so flex-start sizes FeedMain to its
       content instead of the full row and the cards push past the viewport. */
    align-items: stretch;
    flex-direction: column;
    gap: 20px;
  }
`;

export const FeedMain = styled.div`
  flex: 1;
  max-width: 100%;
  min-width: 0;
`;

export const FeedAside = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 16px;
  max-width: 100%;
  min-width: 0;
  width: 340px;

  @media (max-width: 900px) {
    width: 100%;
  }
`;
